export const FETCH_DSR_LOGS_PROD_JOINTS = '@@material/dsr-logs-production-joints';
export const FETCH_DSR_LOGS_PROD_JOINTS_SUCCESS = '@@material/dsr-logs-production-joints-success';
export const FETCH_DSR_LOGS_PROD_JOINTS_FAILURE = '@@material/dsr-logs-production-joints-failure';
